// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"576":"d743698f","754":"8f53eca5","821":"a4afff1c"}[chunkId] + ".chunk.js";
};